import {FC} from "react";
import {Trans, useTranslation} from "react-i18next";
import {Card, CardContent, CardHeader} from "@interstate/components/Card";
import "./SummaryCard.scss";

export interface SummaryCardProps {
  baseKey: string;
  count: number;
}

export const SummaryCard: FC<SummaryCardProps> = ({baseKey, count}) => {
  const {t} = useTranslation();
  return (
    <Card
      className={"create-hierarchy-summary-card"}
      header={<CardHeader title={t(`${baseKey}.title`)} />}
      content={
        <CardContent>
          <Trans
            i18nKey={`${baseKey}.content`}
            values={{count}}
            components={{bold: <strong className={"summary-card-count"} />}}
          />
        </CardContent>
      }
    />
  );
};
